import Field from "@/components/field/field";

import LexicalRichTextEditor from "./lexical-editor";

interface RichTextEditorProps {
  name: string;
  label?: string;
  initialValue?: string;
}

const RichTextEditor = ({ name, label, initialValue = "" }: RichTextEditorProps) => {
  return (
    <Field label={label}>
      <LexicalRichTextEditor name={name} initialValue={initialValue} />
    </Field>
  );
};

export default RichTextEditor;
